import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

// withCredentials: true — send the HttpOnly session cookie on every request.
// The backend accepts EITHER the cookie OR an Authorization: Bearer header,
// so `setAuthToken` still works for test harnesses that want to authenticate
// via a token from the login response body.
const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
  withCredentials: true,
});

let authToken = null;

export function setAuthToken(token) {
  authToken = token;
  if (token) {
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
}

export function getAuthToken() {
  return authToken;
}

export function fileUrl(path) {
  if (!path) return null;
  return `${API_BASE}/uploads/file/${path}`;
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
